<template>
  <div>
    <b-table striped small hover :items="authorsData">
      <template #cell(action)="data">
        <div class="text-right">
          <router-link :to="{ name: 'AuthorDetails', params: {
            id: data.item.id
          }}">
            <b-icon icon="link45deg"></b-icon>
          </router-link>
          <a href="#" v-if="editMode" @click="deleteRow($event, data.item.id)"><b-icon icon="trash"></b-icon></a>
        </div>
      </template>
      <template #cell(id)="data">
        <tdColUUID :value="data.item.id" />
      </template>
    </b-table>
    <b-col sm="4" md="3" v-if="showTotalLable">
      Total {{ authorsData.length }} {{ authorsData.length === 1 ? 'entry' : "entries" }} in table
    </b-col>
  </div>
</template>

<style scoped>
  * >>> th {
    font-size: 10px !important;
    text-transform: uppercase;
    color: #bbbbbb;
  }
</style>

<script>
  import tdColUUID from '@/components/tdColUUID.vue'

  export default {
    name: 'AuthorTable',
    props: ['authors', 'editMode', 'showTotal'],
    data(){
      return {
        showTotalLable: this.showTotal ? this.showTotal : false
      }
    },
    components: {
      tdColUUID
    },
    computed: {
      authorsData(){
        return this.authors.map(author => {
          return {
            id: author.id,
            title: author.title,
            firstName: author.firstName,
            lastName: author.lastName,
            action: ''
          }
        })
      }
    },
    methods: {
      deleteRow(event, id){
        event.preventDefault()
        this.$store.dispatch('addNotification', {
          type: 'warning',
          text: `Author deleted`
        })
        this.$emit('delete', id)
      }
    }
  }
</script>
